<template>
    <div>
        <v-dialog v-model="showInvoiceReceiptPaperModal" @close="close"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition"
                  scrollable>
            <v-card tile>
                <v-toolbar height="55px" card dark class="blue-grey darken-2 white--text">
                    <v-btn icon dark @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Factura/Recibo nº {{selectedInvoice.code + '/' + selectedInvoice.series}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip v-if="isInvoiceCanceled" ma-3 label outline color="red darken-1">Anulado</v-chip>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 sm12 md8 lg7 justify-center>

                                <!--Motivo anulamento fatura-->
                                <v-flex xs12 v-if="!loadingInvoiceReceipt && isInvoiceCanceled">
                                    <v-card style="background-color: #efefef">
                                        <v-card-title>
                                            <span style="font-weight: bold; font-size: 14px">Motivo anulamento</span>
                                        </v-card-title>
                                        <v-card-text style="margin-top: -20px; margin-left: 10px">
                                            {{fetchedInvoiceReceipt.cancel_reason ? fetchedInvoiceReceipt.cancel_reason : 'Não especificado'}}
                                        </v-card-text>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12>
                                    <v-progress-linear
                                            color="indigo"
                                            v-if="loadingInvoiceReceipt"
                                            :indeterminate=true
                                            height="2"
                                            value="15"
                                    ></v-progress-linear>

                                    <div  ref="facturaRecibo" v-else>
                                        <div v-for="(fracturedSellLine, index) in fracturedSellLines.length">
                                            <invoice-receipt-page
                                                :fetchedInvoiceReceipt="fetchedInvoiceReceipt"
                                                :sellLines="fracturedSellLines[index]"
                                                :currentPage="index+1"
                                                :totalPage="fracturedSellLines.length"
                                                :invoicePrintLabel="invoicePrintLabel"
                                                :isInvoiceCanceled="isInvoiceCanceled"
                                                :isA5Format="isA5Format"
                                            
                                            ></invoice-receipt-page>
                                        </div>
                                    </div>
                                </v-flex>

                            </v-flex>

                            <!--Side Buttons-->
                            <v-flex xs12 sm12 md3 lg2 style="margin-top: 25px">
                                <v-flex mx-2 xs12>
                                    <v-btn block :loading="downloadingOriginal" :disable="downloading2via"
                                           class="white--text" mx-2 grow color="indigo lighten-2" @click="downloadPDF(DOWNLOAD_ORIGINAL)">Baixar Original</v-btn>
                                </v-flex>
                                <v-flex mx-2 xs12>
                                    <v-btn block :loading="downloading2via" :disable="downloadingOriginal"
                                           class="white--text" mx-2 grow color="indigo lighten-3" @click="downloadPDF(DOWNLOAD_2VIA)">Baixar 2ª via</v-btn>
                                </v-flex>

                                <v-flex mx-2 xs12>
                                    <v-btn :disabled="loadingInvoiceReceipt || shelving || !selectedInvoice.code || isInvoiceCanceled"
                                           :loading="shelving"
                                           block
                                           class="white--text" mx-2 grow color="blue-grey lighten-3" @click="shelve">{{selectedInvoice.shelved ? 'Desarquivar' : 'Arquivar'}}</v-btn>
                                </v-flex>


                                <v-flex mx-2 mt-4 xs12>
                                    <v-btn :disabled="loadingInvoiceReceipt || isInvoiceCanceled" block class="white--text" mx-2 grow color="red" @click="askCancel">{{isInvoiceCanceled ? 'Anulado' : 'Anular'}}</v-btn>
                                </v-flex>
                                <!--</v-layout>-->
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>

            <!--Cancel Invoice-->
            <v-dialog persistent max-width="500" v-model="invoiceCancelModal" @close="invoiceCancelModal = false">
                <v-card>
                    <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                    <v-card-text class="text-xs-center">
                        <p><span class="red--text text--lighten-1">Cuidado! Esta ação não poderá ser revertida.</span></p>
                        <p style="margin-top: -10px; margin-bottom: 10px" class="text-xs-center">Deseja anular esta factura mesmo assim?</p>
                        <v-flex>
                            <v-textarea
                                    v-model="cancel_reason"
                                    outline
                                    rows=3
                                    label="Motivo do cancelamento"
                                    hint="Obrigatório"
                                    persistent-hint
                            ></v-textarea>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div v-if="!loading_cancel_invoice">
                            <v-btn color="red darken-1" :disabled="!cancel_reason" flat @click="cancelInvoice()">Sim</v-btn>
                            <v-btn color="grey darken-1" flat @click="invoiceCancelModal = false">Não</v-btn>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-dialog>
    </div>
</template>

<script>
    import Vue from "vue";
    import {Types} from "../../config";
    import {eventBus} from "../../main";
    import {mapGetters} from "vuex";
    import html2pdf from "html2pdf.js";
    import InvoiceReceiptPage from "./InvoiceReceipt/InvoiceReceiptPage.vue";

    export default {

        data(){
            return {
                DOWNLOAD_ORIGINAL: 1,
                DOWNLOAD_2VIA: 2,

                loadingInvoiceReceipt: false,
                sellLines: [],
                fracturedSellLines: [],
                invoicePrintLabel: 'Original',
                fetchedInvoiceReceipt: '',

                shelving: false,
                extraInfosLoaded: false,
                cancel_reason: '',
                invoiceCancelModal: false,
                loading_cancel_invoice: false,
                downloadingOriginal: false,
                downloading2via: false,

                //paper format
                isA5Format: false,
            }
        },

        components:{
            InvoiceReceiptPage,
        },

        watch:{
            showInvoiceReceiptPaperModal(){
                this.invoicePrintLabel = 'Original';
                if(this.showInvoiceReceiptPaperModal) this.onFormModalOpened(this);
            }
        },

        computed: {
            ...mapGetters([
                'loggedUser',
                'getToken',
            ]),
            
            showReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowReceiptPaperModal', value);
                }
            },
            selectedReceipt: {
                get() {
                    return this.$store.getters.getSelectedReceipt;
                },
                set(value) {
                    this.$store.dispatch('setSelectedReceipt', value);
                }
            },
            showInvoiceReceiptPaperModal: {
                get() {
                    return this.$store.getters.getShowInvoiceReceiptPaperModal;
                },
                set(value) {
                    this.$store.dispatch('setShowInvoiceReceiptPaperModal', value);
                }
            },

            selectedInvoice: {
                get(){
                    return this.$store.getters.getSelectedInvoice;
                },
                set(value){
                    this.$store.dispatch('setSelectedInvoice', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },

            getCurrency(){
                try {
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.ECV) return 'ECV';
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.DOLLAR) return 'Dollar';
                    if(this.fetchedInvoiceReceipt.sell.types_currency_id === Types.currency.EURO) return 'Euro';
                    // return this.fetchedInvoiceReceipt.sell.type_currency.name;
                    return '';
                }catch (e) {
                    return '$$$';
                }
            },

            getFileName(){
                return 'FacturaRecibo_'+this.selectedInvoice.code+''+this.selectedInvoice.series+'.pdf'
            },

            isInvoiceCanceled(){
                return this.selectedInvoice.types_operation_type_id === Types.operation_type.ANULADO;
            },
                        
            getSellLines(){
                return this.sellLines;
                // return this.getSellLinesTesting; //used for testing
            },
            
            //used for testing purpouse, to check when invoice has many sellLines
            getSellLinesTesting(){ //TODO remove later, it is only for testing
                let mArray = [];
                // this.consoleLog('sellLines: ', this.sellLines);
                
                for(let i = 0; i <= 60; i++){
                    let sellLineCopy = JSON.parse(JSON.stringify(this.sellLines[0]));
                    if(sellLineCopy && sellLineCopy.article) sellLineCopy.article.name = 'Item '+(i+1)+ ' a realllyyyy loonng tenxt, for testing purpouse only nothing, no reason to spcificaly make a huge line like this. Hmm just a moment, maybe this sentence is not that long as we uspected before, maybe it could be increase just  a litle bit more.';
                    mArray.push(sellLineCopy);
                }
                // this.consoleLog('sellLinesTEESST: ', mArray);
                return mArray;
            },
        },

        methods:{
            setUpFracturedSellLines(){
                const a4_maxLine = 14;
                const a5_maxLine = 6;
                let maxLine = this.isA5Format ? a5_maxLine : a4_maxLine;

                if(!this.getSellLines) return [];

                let cont = 1, mArrayIndex = 0;
                let inArray = [];
                let totalLength = this.getSellLines.length
                for(let i=0; i < totalLength; i++){
                    
                    inArray.push(this.getSellLines[i]);

                    if(cont > maxLine || i == totalLength-1){
                        this.fracturedSellLines[mArrayIndex] = inArray;
                        mArrayIndex++;
                        cont = 1;
                        inArray = [];
                    }else{
                        cont++;
                    }

                }
                this.consoleLog('getFracturedSellLines: ', this.fracturedSellLines);

            },

            downloadPDF(option){
                if (option === this.DOWNLOAD_ORIGINAL){
                    this.invoicePrintLabel = 'Original';
                    this.downloadingOriginal = true;
                }else if(option === this.DOWNLOAD_2VIA){
                    this.invoicePrintLabel = '2ª via';
                    this.downloading2via = true;
                }
                setTimeout(() => {
                    this.downloadPDFWorker();
                }, 200);

            },

            async downloadPDFWorker() {
                const el = this.$refs.facturaRecibo;

                let opt = {
                    margin:       0,
                    filename:     this.getFileName,
                    image:        { type: 'jpeg', quality: 1 },
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: this.isA5Format ? 'a5' : 'a4', orientation: 'portrait' },
                    pdfCallback: this.pdfCallback()
                };

                let pdf = html2pdf().from(el).set(opt);
                pdf.save();
            },

            pdfCallback() {
                // alert("finished downloading")
                this.downloadingOriginal = false;
                this.downloading2via = false;

                // var number_of_pages = pdfObject.internal.getNumberOfPages();
                // var pdf_pages = pdfObject.internal.pages;
                // var myFooter = "Footer info";
                // for (var i = 1; i < pdf_pages.length; i++) {
                //     // We are telling our pdfObject that we are now working on this page
                //     pdfObject.setPage(i);
                //     // The 10,200 value is only for A4 landscape. You need to define your own for other page sizes
                //     pdfObject.text(myFooter, 10, 200)
                // }
            },

            onFormModalOpened(){
                if(!this.showInvoiceReceiptPaperModal) return; //proceed only if the model was open, not closed

                this.fetchReceiptInvoices();
            },

            fetchReceiptInvoices(){
                this.loadingInvoiceReceipt = true;
                try{
                    Vue.axios.get('invoice/invoice_receipt/'+this.selectedInvoice.id)
                        .then(response => {
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }
                            this.fetchedInvoiceReceipt = response.data.response;
                            this.sellLines = response.data.response.sell.sell_lines;

                            let settings = response.data.response.sell.company.settings;
                            this.isA5Format = settings[0].invoice_receipt_format === "A5"
                            
                            this.setUpFracturedSellLines();


                        }).catch(error => {
                        this.consoleLog(error);
                        // this.showSnackBar('Ocorreu um erro ao atualizar cliente', 'error');
                    }).finally( ()=> {
                        this.company_modal_loading = false;
                        this.loadingInvoiceReceipt = false;
                        // this.loading_modal = false;
                    });
                }catch (e) {
                    this.consoleLog(e);
                }
            },


            askCancel(){
                this.invoiceCancelModal = true;
            },

            cancelInvoice(){
                try{
                    this.loading_cancel_invoice = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/cancel/'+this.selectedInvoice.id, {
                        id: this.selectedInvoice.id,
                        cancel_reason: this.cancel_reason,
                    })
                        .then(response =>{
                            this.consoleLog(response);
                            // let str = !this.selectedInvoice.shelved ? 'arquivado' : 'desarquivado';
                            if(!response.data.success){
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }
                            let invoice = response.data.response.invoice;

                            this.close();
                            // this.selectedInvoice.types_operation_type_id = response.data.response.invoice.types_operation_type_id;
                            // this.showSnackBar('Factura '+this.selectedInvoice.code+' anulado com sucesso', 'success');
                            eventBus.$emit('onCancelingInvoice', invoice, 'Fatura/Recibo');

                        }).catch(error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.loading_cancel_invoice = false;
                        this.invoiceCancelModal = false;
                    });
                }catch (e) {
                    this.consoleLog(e);
                }
            },

            shelve() {
                try{
                    this.shelving = true;
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('invoice/shelve/'+this.selectedInvoice.id, {
                        id: this.selectedInvoice.id,
                        name: this.selectedInvoice.code,
                    }).then(response =>{
                        let str = !this.selectedInvoice.shelved ? 'arquivado' : 'desarquivado';
                        if(!response.data.success){
                            this.showSnackBar('Erro ao '+str+' a factura '+this.selectedInvoice.code+'.', 'error');
                            return;
                        }
                        this.selectedInvoice.shelved = response.data.response.invoice.shelved;
                        str = this.selectedInvoice.shelved ? 'arquivado' : 'desarquivado';
                        this.showSnackBar('Factura/Recibo '+this.selectedInvoice.code+'/'+this.selectedInvoice.series+' '+str+' com sucesso', 'success');
                        eventBus.$emit('onShelveUnshelve', true, this.selectedInvoice);

                    }).catch(error => {
                        this.consoleLog(error);
                    }).finally(()=>{
                        this.shelving = false;
                    });
                }catch (e) {
                    //Do nothing for now
                }
            },

            close(){
                this.loadingInvoiceReceipt = false;
                this.showInvoiceReceiptPaperModal = false;
            },
        },

    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }

    footer {
        position: fixed;
        bottom: 0;
        margin-bottom: 0;
        font-size: 11px;

        /*margin-top: 8mm;*/
    }
</style>